require("./bootstrap");

window.Vue = require("vue");

// Main JS Metronic Vue imports and settings
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueAuth from "@websanova/vue-auth";
import authBearer from "@websanova/vue-auth/dist/drivers/auth/bearer.esm.js";
import httpAxios from "@websanova/vue-auth/dist/drivers/http/axios.1.x.esm";
import authRouter from "@websanova/vue-auth/dist/drivers/router/vue-router.2.x.esm";

import App from "./App.vue";
import router from "./router";
import store from "./core/services/store";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";


// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;
Vue.config.productionTip = false;

import i18n from "./core/plugins/vue-i18n";
import vuetify from "./core/plugins/vuetify";
import "./core/plugins/portal-vue";
import "./core/plugins/perfect-scrollbar";
import "./core/plugins/highlight-js";
import "./core/plugins/inline-svg";
import "./core/plugins/apexcharts";
import "./core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import Vuelidate from "vuelidate";

// Configuração do cliente
const CLIENT =
  process.env.MIX_APP_CLIENT === undefined
    ? "default"
    : process.env.MIX_APP_CLIENT;
const clientData = require(`@/client/${CLIENT}/data.json`);
require(`@/client/${CLIENT}/theme.scss`);

Vue.router = router;

Vue.use(VueAxios, axios);
Vue.axios.defaults.baseURL = window.API_BASE_URL;

Vue.use(Vuelidate);
Vue.use(VueAuth, {
  auth: authBearer,
  http: httpAxios,
  router: authRouter,
  refreshData: { enabled: false }
});

// Evento para resetar layout em cada navegação
router.beforeEach((to, from, next) => {
  store.dispatch(RESET_LAYOUT_CONFIG);
  next();
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

// Message responseHandler
import "./services/message_handler";
require("./global_filters.js");

// Inicialização da aplicação
// eslint-disable-next-line
const app = new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App)
}).$mount("#app");

export default { CLIENT, clientData };